import React from 'react'
import classNames from 'classnames'

export interface ContainerProps {
    children: React.ReactNode
    hasPadding?: boolean
    className?: string
}

const Container = (props: ContainerProps): JSX.Element => {
    const className: string = classNames('container', { 'container--padded': props.hasPadding }, props.className)

    return <div className={className}>{props.children}</div>
}

export default Container
